import { REQUIRED } from 'constants/errors';

export const substanceDrugTypeValidator = {
  presence: true,
  // DrugType.tsx uses 'Other' to save the selection, but the user still needs
  // to fill out explanation. Due to this, we show the 'REQUIRED' error
  // message to indicate that the field is required.
  hasValue: { validator: { exclusion: { within: ['Other'], message: REQUIRED } } },
};
